<template>
    <a-col :span="24">
      <a-row class="max1200">
        <a-row class="content">
          <slot name="content">
          </slot>
        </a-row>
      </a-row>
    </a-col>
</template>

<script>
export default {
    name: 'BasicContent',
}
</script>

<style scoped>

  .max1200 {
      max-width: 1200px;
      margin: auto;
      height: 100%;
      padding: 0px 8px;
  }
  .content {
    margin-top: 8px;
    height: 100%;
    //border: 1px solid #d1d5da;
    //border-radius: 3px 3px 0px 0px;
  }
</style>
